import { Component, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { NavigationEnd, Router } from "@angular/router";
import { DEFAULT_INTERRUPTSOURCES, Idle } from "@ng-idle/core";
import { Keepalive } from "@ng-idle/keepalive";

import * as $ from "jquery";
import { NgwWowService } from "ngx-wow";
import { ToastsManager } from "ng2-toastr/ng2-toastr";
import { TranslationService } from "./_services/translation.service";
import { ApplicationService } from "./_services/application.service";
import { AuthenticationService } from "./_services/authentication.service";
import { DataService } from "./_services/data.service";
import { SessionManagerService } from "./_services/SessionManager/session-manager.service";

@Component({
  moduleId: module.id,
  // tslint:disable-next-line:component-selector
  selector: "app",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent implements OnInit {
  @ViewChild("f") f: NgForm;
  newsModel: any = {};
  loading = false;
  currentUser: any;
  siteId: any;
  contactModel: any = {};
  loadingContact = false;
  idleState = "Not started.";
  timedOut = false;
  lastPing?: Date = null;
  counterBtnCount: number;
  public isPersonalBlockHidden: boolean = true;
  public developmentEaseThinPadding: boolean = false;

  //   private wowSubscription: Subscription;

  constructor(
    private applicationService: ApplicationService,
    private wowService: NgwWowService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private toastr: ToastsManager,
    private idle: Idle,
    private keepalive: Keepalive,
    private dataService: DataService,
    private sessionManagerService: SessionManagerService,
    // removed it because its confusing in tests
    private tservice: TranslationService
  ) {
    this.wowService.init();
    this.dataService.getMessages().subscribe(
      (data) => {
        this.currentUser = data && data["user"] ? data["user"] : undefined;
      },
      (error) => {}
    );
    this.authenticationService.siteId.subscribe(
      (data) => {
        this.siteId = data;
      },
      (error) => {}
    );

    this.authenticationService.currentUser.subscribe((nextVal) => {
      this.currentUser =
        nextVal && nextVal.role !== "GUEST" ? nextVal : undefined;
    });

    $(document).ready(function () {
      $(window).on("scroll", function () {
        if ($(".toolBar").is(":visible")) {
          if ($(window).scrollTop() > 0) {
            $(".toolBar").addClass("fixedToolBar").removeClass("topToolBar");
            $(".accessibility-icon").addClass("fixed-icon");
          } else {
            $(".toolBar").addClass("topToolBar").removeClass("fixedToolBar");
            $(".fixed-icon").removeClass("fixed-icon");
          }
        }
      });
    });
    idle.setIdle(30 * 60);
    idle.setTimeout(30 * 60);
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.idleState = "No longer idle.";
    });
    idle.onTimeout.subscribe(() => {
      this.idleState = "Timed out!";
      this.timedOut = true;
      this.logout();
    });
    idle.onIdleStart.subscribe(() => (this.idleState = "You've gone idle!"));
    idle.onTimeoutWarning.subscribe(
      (countdown) =>
        (this.idleState = "You will time out in " + countdown + " seconds!")
    );

    keepalive.interval(30);

    keepalive.onPing.subscribe(() => (this.lastPing = new Date()));
  }

  setIdle(evt: NavigationEnd) {
    const notIdleArr = [
      "/login",
      "/forgotpassword",
      "/questions-answers",
      "/register",
    ];
    if (notIdleArr.indexOf(evt.url) < 0) {
      this.idle.watch();
      this.idleState = "Started.";
      this.timedOut = false;
    } else {
      this.idle.stop();
    }
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      this.isPersonalBlockHidden = evt.url === "/login";
      this.setIdle(evt);

      window.scrollTo(0, 0);
    });
    this.applicationService.counterBtnCount.subscribe((counterBtnCount) =>
      setTimeout(() => {
        this.counterBtnCount = counterBtnCount;
      })
    );
  }

  public ngOnDestroy() {}

  public registerNewsletter() {
    this.loading = true;
    this.dataService.newsletter(this.newsModel).subscribe(
      (data) => {
        this.loading = false;
        this.newsModel = {};
      },
      (error) => {
        this.loading = false;
        console.error(error);
      }
    );
  }

  contactForm() {
    if (!this.loadingContact) {
      this.loadingContact = true;
      this.dataService.contactForm(this.contactModel).subscribe(
        (data) => {
          this.loadingContact = false;
          this.f.resetForm();
          this.toastr.success("הפנייה התקבלה והועברה לטיפול", "הצלחה!");
        },
        (error) => {
          this.loadingContact = false;
          console.error(error);
        }
      );
    }
  }

  logout() {
    this.authenticationService.logout();
    location.reload();
  }

  counterBtnClick() {
    this.applicationService.nextCounterBtnClicked(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts